import { useAppContext } from '../../context/Context';
import { ACTION } from '../../context/actionTypes';
import RagContentDisplay from './RagContentDisplay';
import {RagOutput} from "../../types/chat";
import WideGenericModal from '../../utils/WideGenericModal';


export interface DisplayRagModalProps {
    rag: RagOutput;
    showPercentages: boolean;
    companyUUID: string;
}


export default function DisplayRagModal({rag, showPercentages, companyUUID}: DisplayRagModalProps) {
    const [, dispatch] = useAppContext()

    return (
        <WideGenericModal
            showCloseButton={true}
            exitClick={true}
            blurBackGround={true}
            toggleMe={() => dispatch({ type: ACTION.SET_GENERIC_MODAL, payload: null })}
        >
            <RagContentDisplay rag={rag} showPercentages={showPercentages} forceDisplayContent={true} companyUUID={companyUUID} />
        </WideGenericModal>
    )
}
